import React, { useContext, useEffect, useState } from "react";
import { PlusOutlined, MinusCircleOutlined, ArrowLeftOutlined, DeleteOutlined, FilePdfOutlined, FileWordOutlined, FileImageOutlined, FileUnknownOutlined, UploadOutlined } from "@ant-design/icons";
import {
  Col,
  Row,
  Form,
  Input,
  message,
  Card,
  Select,
  DatePicker,
  Button,
  Modal,
  Upload
} from "antd";
import { useNavigate } from "react-router-dom";
import "dayjs/locale/en";
import { BiSolidInbox, BiUpload } from "react-icons/bi";
import { MdDeleteOutline } from "react-icons/md";
import { AuthContext } from "../../Auth/AuthContext";
import { addProject, getCustomers, getProjectByID, updateProject, getallProject, getallDeveloperForTask } from "../../utils/API";
import { FaUpload } from "react-icons/fa";
import Edit from "../Developers/Edit";
import dayjs from "dayjs";
import { useParams } from "react-router-dom";
import { UploadChangeParam } from "antd/es/upload";
import { UploadFile } from "antd/lib";
import { RcFile } from "antd/lib/upload";
const { Option } = Select;

interface EditProjectModalProps {
  visible: boolean;
  taskId?: string;
  customerId?: string;
  onClose?: () => void;
  onEdit?: () => void;
  onCancel?: () => void;
  onSuccess?: () => void; // Changed from any to void
}
const EditProjectModal: React.FC<EditProjectModalProps> = (props) => {
  const IMAGEURL = process.env.REACT_APP_IMAGE_URL + '/projects/';

  const { id } = useParams();
  const navigate = useNavigate();
  const { visible, onCancel, taskId, onClose, customerId } = props;
  const { authData } = useContext(AuthContext);

  const [Purposal, setPurposal] = useState<Array<string | File>>([]);
  const [fileListPurposal, setFileListPurposal] = useState<any[]>([]);
  const [Contract, setContract] = useState<Array<string | File>>([]);
  const [fileListContract, setFileListContract] = useState<any[]>([]);

  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = React.useState(false);
  const [clients, setClients] = useState<any>([]);
  const [project, setProject] = useState<any>(null);
  const user_id = authData.user._id;
  const [developers, setDevelopers] = useState<{ _id: string; username: string }[]>([]);
  const roleId = authData.roleId;

  useEffect(() => {
    const fetchDevelopers = async () => {
      try {
        const response: any = await getallDeveloperForTask("", "");
        setDevelopers(response?.data || []);
      } catch {
        message.error("Failed to load developers");
        setDevelopers([]);
      }
    };

    fetchDevelopers();
  }, []);

  const handleEdit = async (values: any) => {
    try {
      setIsLoading(true);
      const formData = new FormData();

      // Append regular fields
      Object.keys(values).forEach((key) => {
        if (key !== "purposal" && key !== "contract" && key !== "milestones") {
          if (key === "assignees") {
            const list = Array.isArray(values.assignees)
              ? values.assignees
              : String(values.assignees).split(",").map((id) => id.trim());

            list.forEach((id: string | Blob) => formData.append("assignees[]", id));
          } else if (values[key] !== null && values[key] !== undefined && values[key] !== "") {
            // ✅ Only append if the value exists
            // Handle dayjs date conversion
            if (dayjs.isDayjs(values[key])) {
              formData.append(key, values[key].toISOString());
            } else {
              formData.append(key, values[key]);
            }
          }
        }
      });

      if (values.milestones) {
        formData.append("milestones", JSON.stringify(values.milestones));
      }

      // Merge existing and newly uploaded Purposal files
      Purposal.forEach((file) => {
        // If it's a File object, send as file
        if (file instanceof File) {
          formData.append("purposal", file);
        } else {
          // If it's a string (existing file path), send as string
          formData.append("purposalExisting", file); // backend should handle this
        }
      });

      // Merge existing and newly uploaded Contract files
      Contract.forEach((file) => {
        if (file instanceof File) {
          formData.append("contract", file);
        } else {
          formData.append("contractExisting", file); // backend should handle this
        }
      });

      if (props.taskId) {
        await updateProject(props.taskId, formData, user_id);
        message.success("Project updated successfully!");
      } else {
        await addProject(formData);
        message.success("Project added successfully!");
      }
      getallProject("", "");
      props.onSuccess?.();
    } catch (error: any) {
      message.error(error.response?.data?.message || "Failed to save project");
    } finally {
      setIsLoading(false);
    }
  };


  useEffect(() => {
    const fetchClients = async () => {
      try {
        const response: any = await getCustomers("", "");

        if (response?.data) {
          // Filter only active clients
          const activeClients = response.data.filter(
            (client: any) => client.isActive === true
          );
          setClients(activeClients);
        }
      } catch (error) {
        console.error("Error fetching clients:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchClients();
  }, []);

  useEffect(() => {
    if (project) {
      form.setFieldsValue({
        projectName: project.projectName,
        clientId: project.clientId?._id, // Ensure client ID is set properly
        assignees: project.assignees?.map((user: any) => user._id) || [],
        startDate: project.startDate ? dayjs(project.startDate) : null,
        completionDate: project.completionDate ? dayjs(project.completionDate) : null,
        endingDate: project.endingDate ? dayjs(project.endingDate) : null,
        review: project.review,
        budget: project.budget,
        milestones: project.milestones?.map((milestone: any) => ({
          date: dayjs(milestone.date), // Convert date to dayjs object
          comment: milestone.comment,
        })) || [],
      });
      if (project.purposal) {
        const purposal = Array.isArray(project.purposal)
          ? project.purposal
          : [project.purposal];

        setPurposal(purposal);

        setFileListPurposal(
          purposal.map((purposal: string, index: number) => ({
            uid: `existing-${index}-${Date.now()}`,
            name: purposal.split('/').pop() || 'purposal',
            status: 'done',
            url: `${IMAGEURL}${purposal}`,
            ...(purposal.match(/\.(jpg|jpeg|png|gif|webp)$/i)
              ? {
                preview: `${IMAGEURL}${purposal}`,
              }
              : {}),
          }))
        );
      }

      if (project.contract) {
        const contract = Array.isArray(project.contract)
          ? project.contract
          : [project.contract];

        setContract(contract);

        setFileListContract(
          contract.map((contract: string, index: number) => ({
            uid: `existing-${index}-${Date.now()}`,
            name: contract.split('/').pop() || 'contract',
            status: 'done',
            url: `${IMAGEURL}${contract}`,
            ...(contract.match(/\.(jpg|jpeg|png|gif|webp)$/i)
              ? {
                preview: `${IMAGEURL}${contract}`,
              }
              : {}),
          }))
        );
      }
    }
  }, [project, form]);



  const fetchProject = async () => {
    setIsLoading(true);
    try {
      if (props.taskId) {  // Only fetch if we have a taskId
        const data = await getProjectByID(props.taskId);
        setProject(data);
      }
    } catch (error) {
      message.error("Failed to fetch project data.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchProject();
  }, [props.taskId]);  // Watch for changes in taskId


  const getFileIcon = (fileName: string) => {
    const ext = fileName.split(".").pop()?.toLowerCase();

    if (ext === "pdf") return <FilePdfOutlined className="text-2xl text-red-500 mb-1" />;
    if (ext === "doc" || ext === "docx") return <FileWordOutlined
      className="text-2xl text-blue-500 mb-1" />;
    if (ext === "jpg" || ext === "jpeg" || ext === "png")
      return <FileImageOutlined className="text-2xl text-green-500 mb-1" />;

    // default fallback
    return <FileUnknownOutlined className="text-2xl text-gray-500 mb-1" />;
  };

  const handleDeletePurposal = (doc: string | File, index: number) => {
    const newPurposal = [...Purposal];
    newPurposal.splice(index, 1);
    setPurposal(newPurposal);

    const newFileListPurposal = [...fileListPurposal];
    newFileListPurposal.splice(index, 1);
    setFileListPurposal(newFileListPurposal);
  };

  const handleDeleteContract = (doc: string | File, index: number) => {
    const newContract = [...Contract];
    newContract.splice(index, 1);
    setContract(newContract);

    const newFileListContract = [...fileListContract];
    newFileListContract.splice(index, 1);
    setFileListContract(newFileListContract);
  };

  return (
    <Modal

      visible={visible}
      onCancel={onClose}
      footer={null}
      width={700}
      centered // Disable centered to use top positioning
      destroyOnClose
      className="custom-modal project-form-modal"
      bodyStyle={{
        maxHeight: "calc(100vh - 64px)",
        overflowX: "hidden",
        overflowY: "auto",
        fontFamily: "inter, sans-serif",
      }}
      styles={{
        header: {
          padding: "12px",
          position: "sticky",
          top: 0,
          backgroundColor: "#f1f5ffff",
        },
        content: {
          padding: 0,
          overflow: "hidden",
        },
      }}
      title={
        <div
          style={{
            color: "#4b5563",
            fontFamily: "inter, sans-serif",
            fontSize: "20px",
            fontWeight: 500,
          }}
        >
          Edit Project
        </div>
      }
    >
      <Form
        onFinish={handleEdit}
        form={form}
        layout="horizontal"
        labelCol={{ span: 5 }}
        wrapperCol={{ span: 19 }}
        colon={false}
      >
        <div className="elements">
          {/* name */}
          <Form.Item
            label={
              <span style={{
                color: '#4b5563',
                fontFamily: 'inter, sans-serif',
                fontWeight: 500,
                paddingLeft: "15px",
              }}>
                Project Name <span className="text-danger">*</span>
              </span>
            }
            name="projectName"
            required={false}
            rules={[{ required: true, message: "Please Enter Name" }]}
          >
            <Input
              size="large"
              disabled={roleId == 2}
              className="Allinput"
              placeholder="Project Name"
            />
          </Form.Item>


          <Form.Item
            label={<span style={{
              color: '#4b5563',
              fontFamily: 'inter, sans-serif',
              fontWeight: 500,
              paddingLeft: "15px",
            }}>Client Name<span className="text-danger">*</span></span>}
            name="clientId"
            required={false}
            rules={[{ required: true, message: "Please Select Client" }]}
          >
            <Select
              size="large"

              disabled={roleId === 2}
              loading={isLoading}
              placeholder="Select Client"
              className="CustomSelect"
            >
              {clients.map((client: any) => (
                <Select.Option key={client._id} value={client._id}>
                  {client.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            label={<span style={{
              color: '#4b5563', // Medium gray color similar to the image
              fontFamily: 'inter, sans-serif', // Matches the clean sans-serif style
              fontSize: '14px', // Approximate font size based on the image
              fontWeight: 500, // Medium weight to match "font-medium"
              paddingLeft: "15px",
            }}>Assignees</span>}
            required={false}
            name="assignees"


            rules={[{ required: true, message: "Please select at least one assignee" }]}
          >
            <Select mode="multiple" placeholder="Select Assignees"
              filterOption={(input, option) =>
                (option?.children ?? "")
                  .toString()
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }>
              {developers.map((dev) => (
                <Option key={dev._id} value={dev._id}>
                  {dev.username}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            label={<span style={{
              color: '#4b5563',
              fontFamily: 'inter, sans-serif',
              fontWeight: 500,
              paddingLeft: "15px",
            }}>Start Date<span className="text-danger">*</span></span>}
            name="startDate"
            required={false}
            rules={[{ required: true, message: "Please Select Start Date" }]}
          >
            <DatePicker
              size="large"
              disabled={roleId == 2}
              format="DD-MM-YYYY"
              placeholder="Select Start Date"
              className="Allinput"
              getPopupContainer={(trigger) => trigger.parentElement!}
            />
          </Form.Item>



          {/* Completion Date */}
          <Form.Item
            label={
              <span style={{
                color: '#4b5563',
                fontFamily: 'inter, sans-serif',
                fontWeight: 500,
                paddingLeft: "15px",
              }}>
                Target Date <span className="text-danger">*</span>
              </span>
            }
            required={false}
            name="completionDate"
            rules={[{ required: true, message: "Please Select Target Date" }]}
          >
            <DatePicker
              size="large"
              disabled={roleId == 2}
              className="Allinput"
              placeholder="Select Target Date"
              format="DD-MM-YYYY"
              getPopupContainer={(trigger) => trigger.parentElement!}
            />
          </Form.Item>


          {/* Ending Date */}

          <Form.Item
            label={
              <span style={{
                color: '#4b5563',
                fontFamily: 'inter, sans-serif',
                fontWeight: 500,
                paddingLeft: "15px",
              }}>
                Complete Date
              </span>
            }
            name="endingDate"
            required={false}
          >
            <DatePicker
              size="large"
              disabled={roleId == 2}
              className="CustomSelect"
              placeholder="Select Complete Date"
              format="DD-MM-YYYY"
              getPopupContainer={(trigger) => trigger.parentElement!}
            />
          </Form.Item>


          {/* budget*/}

          <Form.Item
            label={<span style={{
              color: '#4b5563',
              fontFamily: 'inter, sans-serif',
              fontWeight: 500,
              paddingLeft: "15px",
            }}>Budget</span>}
            name="budget"
          >
            <Input
              type="number"
              size="large"
              className="Allinput"
              placeholder="Budget"
              defaultValue={0}
            />
          </Form.Item>


          {/* Milestone */}
          <Form.Item label={<span style={{
            color: '#4b5563',
            fontFamily: 'inter, sans-serif',
            fontWeight: 500,
            paddingLeft: "15px",
          }}>Milestones</span>} colon={false}>
            <Form.List name="milestones">
              {(fields, { add, remove }) => (
                <div className="milestone-wrapper">
                  {/* Add Milestone Button at the Top */}
                  <Button
                    type="dashed"
                    onClick={() => add()}
                    icon={<PlusOutlined />}
                    className="w-100 mb-3"
                  >
                    Add Milestone
                  </Button>

                  {/* Milestone Cards - rendered in reverse order */}
                  {fields.map(({ key, name, ...restField }, index) => (
                    <div key={key} className="subtask-card" style={{ order: -index }}>
                      <div className="row project-milestone-row">
                        {/* Milestone Date */}
                        <div className="column project-milestone-column">
                          <Form.Item
                            {...restField}
                            name={[name, "date"]}
                            rules={[{ required: true, message: "Please select a date" }]}
                          >
                            <DatePicker
                              size="large"
                              disabled={roleId == 2}
                              className="subtask-input"
                              format="DD-MM-YYYY"
                              placeholder="Select Milestone Date"
                              getPopupContainer={(trigger) => trigger.parentElement!}
                            />
                          </Form.Item>
                        </div>

                        {/* Milestone Comment */}
                        <div className="column project-milestone-column">
                          <Form.Item
                            {...restField}
                            name={[name, "comment"]}
                            rules={[{ required: true, message: "Please enter a comment" }]}
                          >
                            <Input
                              size="large"
                              disabled={roleId == 2}
                              className="subtask-input"
                              placeholder="Enter Milestone Comment"
                            />
                          </Form.Item>
                        </div>
                      </div>

                      {/* Remove Button */}
                      <div className="delete-btn-container">
                        <Button
                          danger
                          type="text"
                          icon={<DeleteOutlined />}
                          onClick={() => remove(name)}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </Form.List>
          </Form.Item>
          <Col span={24}>
            <Form.Item
              label={<span style={{
                color: '#4b5563',
                fontFamily: 'inter, sans-serif',
                fontSize: '14px',
                paddingLeft: "15px",
                fontWeight: 500,
              }}>Proposal</span>}
              name="purposal"
              valuePropName="fileList"
              getValueFromEvent={(e) => e.fileList}
            >
              <div className="flex flex-col gap-3">
                <div
                  className="project-upload-layout grid grid-cols-[auto,minmax(0,1fr)] items-start gap-4"
                >
                  <Upload
                    action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                    listType="picture-card"
                    // maxCount={1}
                    showUploadList={false}
                    fileList={fileListPurposal}
                    onChange={(info: UploadChangeParam<UploadFile<RcFile>>) => {
                      const rawFiles = info.fileList
                        .map((f) => f.originFileObj)
                        .filter((f): f is RcFile => !!f);

                      setPurposal(rawFiles);
                      setFileListPurposal(info.fileList);
                    }}
                    beforeUpload={() => false}
                  >
                    <Button
                      icon={<UploadOutlined />}
                    // disabled={resumes.length > 0} // Visual disabled state
                    >
                      Upload
                    </Button>
                  </Upload>

                  <div className="grid min-w-0 grid-cols-1 gap-3">
                    {Purposal.map((doc, index) => {
                      if (!doc) return null;

                      const fileName =
                        typeof doc === "string"
                          ? doc.split("/").pop() || ""
                          : (doc as File).name;

                      const fileUrl =
                        typeof doc === "string"
                          ? `${IMAGEURL}${doc}`
                          : URL.createObjectURL(doc as File);

                      return (
                        <div
                          key={index}
                          className="flex min-w-0 items-center justify-between gap-2 rounded-lg border border-gray-200 bg-white p-2 shadow-sm"
                        >
                          <div className="flex min-w-0 flex-1 items-center gap-2 overflow-hidden">
                            {getFileIcon(fileName)}
                            <a
                              href={fileUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="max-w-full truncate text-sm font-medium hover:underline"
                            >
                              {fileName}
                            </a>
                          </div>

                          <button
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              handleDeletePurposal(doc, index);
                            }}
                            className="text-red-500 hover:text-red-700"
                          >
                            <DeleteOutlined />
                          </button>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label={
                <span
                  style={{
                    color: "#4b5563",
                    fontFamily: "inter, sans-serif",
                    fontSize: "14px",
                    paddingLeft: "15px",
                    fontWeight: 500,
                  }}
                >
                  NDA/Contract
                </span>
              }
              name="contract"
              valuePropName="fileList"
              getValueFromEvent={(e) => e.fileList}
            >
              <div className="flex flex-col gap-3">
                <div
                  className="project-upload-layout grid grid-cols-[auto,minmax(0,1fr)] items-start gap-4"
                >
                  {/* Upload Button */}
                  <Upload
                    listType="picture-card"
                    showUploadList={false}
                    multiple
                    fileList={fileListContract}
                    onChange={(info: UploadChangeParam<UploadFile<RcFile>>) => {
                      const rawFiles = info.fileList
                        .map((f) => f.originFileObj)
                        .filter((f): f is RcFile => !!f);

                      setContract(rawFiles);
                      setFileListContract(info.fileList);
                    }}
                    beforeUpload={() => false}
                  >
                    <Button icon={<UploadOutlined />}>Upload</Button>
                  </Upload>

                  {/* Uploaded Files Grid (2 per row) */}
                  <div className="grid min-w-0 grid-cols-1 gap-3">
                    {Contract.map((doc, index) => {
                      if (!doc) return null;

                      const fileName =
                        typeof doc === "string"
                          ? doc.split("/").pop() || ""
                          : (doc as File).name;

                      const fileUrl =
                        typeof doc === "string"
                          ? `${IMAGEURL}${doc}`
                          : URL.createObjectURL(doc as File);

                      return (
                        <div
                          key={index}
                          className="flex min-w-0 items-center justify-between gap-2 rounded-lg border border-gray-200 bg-white p-2 shadow-sm"
                        >
                          <div className="flex min-w-0 flex-1 items-center gap-2 overflow-hidden">
                            {getFileIcon(fileName)}
                            <a
                              href={fileUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="max-w-full truncate text-sm font-medium hover:underline"
                            >
                              {fileName}
                            </a>
                          </div>

                          <button
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              handleDeleteContract(doc, index);
                            }}
                            className="text-red-500 hover:text-red-700"
                          >
                            <DeleteOutlined />
                          </button>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>

            </Form.Item>

          </Col>
        </div>

        <Col
          xs={24}
          style={{
            position: "sticky",
            bottom: 0,
            background: "#fff",
            borderTop: "1px solid #f1f5f9",
            padding: "12px 16px",
            display: "flex",
            justifyContent: "flex-end",
            gap: "8px",
            zIndex: 10,
          }}
        >
          <button
            className="allcanclebutton"
            type="button"
            onClick={(e) => {
              e.preventDefault();
              onClose?.();
            }}
            disabled={isLoading}
          >
            Cancel
          </button>
          <button
            className="allsubmitebutton"
            type="submit"
            disabled={isLoading}
          >
            {isLoading ? "Updating..." : "Update"}
          </button>
        </Col>
      </Form>
    </Modal>
  );
};

export default EditProjectModal;




